"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.userGroup.list': 'Grupos de Usuarios',
    'route.userGroup.create': 'Agregar Grupo de Usuarios',
    'route.userGroup.edit': 'Editar Grupo de Usuarios',
};
